import React, { useState, ReactElement } from 'react';
import { Modal, Grid, Button, ModalProps } from 'semantic-ui-react';

interface Props extends ModalProps {
    onCloseClick: Function;
    showConfirmation: boolean;
    children: ReactElement;
}

export default function ModalWithConfirmation(
    props: Props
): React.ReactElement {
    const { onCloseClick, children, showConfirmation } = props;

    const [showConfirmationModal, setShowConfirmationModal] = useState(false);

    const onClose = (): void => {
        if (showConfirmation) {
            setShowConfirmationModal(true);
        } else {
            confirmedClose();
        }
    };

    const confirmedClose = (): void => {
        setShowConfirmationModal(false);
        onCloseClick();
    };

    return (
        <Modal {...props} onClose={onClose}>
            <Modal
                open={showConfirmationModal}
                onClose={(): void => setShowConfirmationModal(false)}
                size="tiny"
                centered={false}
                closeIcon
            >
                <Modal.Header>All unsaved data will be lost!</Modal.Header>
                <Modal.Content>
                    <p>Are you sure you want to close this?</p>
                    <Grid>
                        <Grid.Column mobile={16} tablet={8} computer={8}>
                            <Button
                                type="button"
                                onClick={(): void =>
                                    setShowConfirmationModal(false)
                                }
                                fluid
                                basic
                                primary
                            >
                                Cancel
                            </Button>
                        </Grid.Column>
                        <Grid.Column mobile={16} tablet={8} computer={8}>
                            <Button
                                type="button"
                                primary
                                fluid
                                negative
                                onClick={(): void => confirmedClose()}
                            >
                                Close
                            </Button>
                        </Grid.Column>
                    </Grid>
                </Modal.Content>
            </Modal>
            {children}
        </Modal>
    );
}
